import { QuestionTypeType } from 'Shared/types/ReviewFormTemplate.type';
import { isEmpty } from 'Wpds/components/rich-text/utils/EditorState.utils';

export function videoDecorator(video) {
  if (!video) return null;
  return {
    audioOnly: video.audioOnly,
    file: null,
    preview: video.previewImageUrl,
    url: video.url,
  };
}

export function reviewFormTemplateErrorsForQuestion({ question, answers }) {
  const answer = answers[question.key];
  const questionType = question.type;
  const optional = question.optional;

  let errors = [];

  switch (questionType) {
    case QuestionTypeType.ADJECTIVES_FOR_PROPERTY:
      if (!(answer && answer.adjectives && answer.adjectives.length > 0))
        errors.push('Must select at least one adjective');
      if (!(answer && answer.explanation && answer.explanation.length > 0 && !isEmpty(answer.explanation)))
        errors.push('Must write an explanation');
      break;
    case QuestionTypeType.GIF:
      if (!(answer && answer.gif_url && answer.gif_url.length > 0)) errors.push('Must select a GIF');
      break;
    case QuestionTypeType.TEXTAREA:
      if (!optional && !(answer && answer.text && answer.text.length > 0 && !isEmpty(answer.text)))
        errors.push('Must write an answer');
      break;
    case QuestionTypeType.RATING:
      if (!(answer && answer.rating)) errors.push('Must select a rating');
      if (
        !(answer && answer.explanation && answer.explanation.length > 0 && !isEmpty(answer.explanation)) &&
        question.showExplanation !== false
      )
        errors.push('Must write an explanation');
      break;
  }

  return errors.map(error => {
    return {
      error,
      questionKey: question.key,
    };
  });
}

export function reviewFormTemplateErrors({ reviewFormTemplate, answers }) {
  const questions = reviewFormTemplate.questions;
  return questions.map(question => reviewFormTemplateErrorsForQuestion({ question, answers })).flat();
}
